import { textAlign } from "@mui/system";
import React, { useEffect, useState } from "react";
import { ApiCall, Colors ,GOOGLE_API_KEY} from "../../common/Const";
import Footer from "../pages/Footer";
import Header from "../pages/Header";
import TextBox from "../pages/TextBox";
import Profileleft from "./Profileleft";
import { GoogleMap, LoadScript,Autocomplete } from '@react-google-maps/api';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import EncryptDecrypt from "../../common/Crypto";
import { images } from "../../common/Images";

const Newaddress = () => {

    const libraries = ['places'];
    const [places,setPlaces] = useState([]);
    const [lat,setLat] = useState();
    const [lng,setLng] = useState();
    const[address1,setAddress1] = useState('')
    const[address2,setAddress2] = useState('')
    const[city,setCity] = useState('')
    const[state,setState] = useState('')
    const[postcode,setPostcode] = useState('')
    const[country,setCountry] = useState('')
    const[specify,setSpecify] = useState('home');
    const[error,setError] = useState(false);
    const [cusId, setcusId] = useState(0)

    const navigate = useNavigate();
    const onLoad = (Autocomplete)=>{

        console.log(Autocomplete);
        setPlaces(Autocomplete)
    }

    const DecryptData = async () => {
      let type = "decrypt"
      let format = "text"
      let id = localStorage.getItem('customerId');
      await EncryptDecrypt(id, type, format, (response) => {
        console.log("decode -->", response);
        setcusId(response)
      })
    }

    useEffect(()=>{
      DecryptData();

    },[]);

    console.log(cusId);

    const onPlaceChanged = ()=>{

        if(places !== null){
            setLat(places.getPlace().geometry.location.lat());
            setLng(places.getPlace().geometry.location.lng())
            console.log(places.getPlace());
            setAddress1(places.getPlace().name);
            var getplace = places.getPlace().address_components;
                console.log("slfsldfks;ldfksd;lfs",getplace.length);
            for(var i = 0; i<getplace.length; i++){
                console.log(getplace[i],"address_comp[i]")

                // if(getplace[i].types[0] == "sublocality_level_1"){
                //     setAddress1(getplace[i].long_name);
                // }else 
                if(getplace[i].types[0] == "locality"){
                    setCity(getplace[i].long_name);
                }else if(getplace[i].types[0] == "administrative_area_level_1"){
                    setState(getplace[i].long_name);
                }else if(getplace[i].types[0] == "country"){
                    setCountry(getplace[i].long_name);
                }else if(getplace[i].types[0] == "postal_code"){
                    setPostcode(getplace[i].long_name);
                }else if(getplace[i].types[0] == "route"){
                    setAddress2(getplace[i]);
                }
            }
        }
        else{
            console.log('Autocomplete is not loaded yet');
        }
    }
    console.log('a1',address1,'a2',address2,'city',city,'ctr',country,'state',state,'pc',postcode);

    const specifications =(e)=>{

       
        setSpecify(e.target.id);
    }
    const updateAddress = (e)=>{
        
        e.preventDefault();
        const addressparams = {
            customer_id:cusId,
            address_1:address1,
            address2:address2,
            city:city,
            state:state,
            post_code:postcode,
            country_id:91,
            latitude:lat,
            longitude:lng,
            specification:specify
        };
        console.log(addressparams,"addressparams")
        if(lat != undefined  && lng != undefined){

            ApiCall('addAddress',addressparams).then((data)=>{
                console.log(data.message == 'Success');
                if(data.message == 'Success'){

                    toast.success(data.message, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                      });

                      navigate(-1);
                      
                }
                else{
                    toast.error(data.message, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                      });
                }
            })
        }
        else{
            toast.error('Address field is required', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              })
        }
    }
    // console.log(specify);
  return (
    <>
      <Header make={true} />
      <div className="profile-myaddress ">
        <div
          className="myprofilebox pb-5 "
          style={{ backgroundColor: "#fef4f7", height: "100%" }}
        >
           <div style={{width:"250px"}}>
              <div className="row" style={{marginBottom:"20px"}}>
                <div className="col-5">
                  <a href="javascript:history.go(-1)"><button className="btn btn-basic p-0" style={{background: Colors.Base_color,color:"white"}} ><img src={images.left} width={30}/><span style={{position: "relative",left: "-8px",top: "2px"}}>Back</span></button></a>
                </div>
                <div className="col-7" style={{paddingTop: "7px"}}>
                  <h4>User Profile</h4>
                </div>
              </div>
            </div>
          <div
            className="profilecontainer row mx-0 gap-4"
            style={{ paddingTop: "20px", height: "100%", paddingBottom: '20px' }}
          >
            <Profileleft />
            <div
              className="right col-11 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8"
              style={{
                backgroundColor: Colors.white_color,
                height: "max-content",
                borderRadius: "20px",
                marginBottom: "40px",
              }}
            >
              <div className=" address-field mt-5 ms-3">
                <span
                  style={{
                    color: "#126a38",
                    fontSize: "22px",
                    fontFamily: "AvenirLTStdLight",
                  }}
                >
                  Add new Address
                </span>
                <div className="specifications container mt-4">
                  <span
                    style={{
                      color: "#126a38",
                      fontSize: "22px",
                      fontFamily: "AvenirLTStdLight",
                    }}
                  >
                    Specifications
                  </span>
                  <div className="ms-3 pt-3">
                    <div class="form-check ">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="home"
                        onClick={(e)=>specifications(e)}
                        
                      />
                      <label class="form-check-label a-title" for="home">
                        Home
                      </label>
                    </div>
                    <div class="form-check ">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="work"
                        onClick={(e)=>specifications(e)}
                      />
                      <label class="form-check-label a-title" for="work">
                        Work
                      </label>
                    </div>
                    <div class="form-check ">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="flexRadioDefault"
                        id="others"
                        onClick={(e)=>specifications(e)}
                      />
                      <label class="form-check-label a-title" for="others">
                        Others
                      </label>
                    </div>
                  </div>
                </div>
                <div className="enter-location ms-3  pt-3">
                  <span
                    style={{
                      color: "#126a38",
                      fontSize: "22px",
                      fontFamily: "AvenirLTStdLight",
                    }}
                  >
                    Enter Location
                  </span>
                  <div className="addr-location">
                  <LoadScript googleMapsApiKey={GOOGLE_API_KEY} libraries={libraries}>
                    <Autocomplete className="w-100" onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                    <TextBox
                        type={"text"}
                        place={"Enter Location"}
                        name={"Location"}
                        />
    
                    </Autocomplete>
                 </LoadScript>
 
                  </div>
                </div>
                <div className="d-flex justify-content-center mt-5 mb-5">
                <button
                  type="button"
                  className="btn btn-lg px-4 "
                  style={{
                    backgroundColor: "#126a38",
                    color: "white",
                    fontFamily: "AvenirLTStdLight",
                    fontSize:'15px',
                    textAlign:'center'
                  }}
                  onClick={updateAddress}
                >
                  Save & update
                </button>
            
               

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />

      <Footer />
    </>
  );
};

export default Newaddress;
